// extracted by mini-css-extract-plugin
export default {"background":"AddForm_background__amtq7","formContent":"AddForm_formContent__9FwI-","addForm":"AddForm_addForm__DcEla","form":"AddForm_form__510wo"};